<template>
  <BoxCard>
    <template #header>
      <div class="header-container full-width">
        <ChartHeader
          :report-url="baseDetailReportURL"
          title="Opportunities"
          tooltip-text="Opportunities = Opportunities Won + Opportunities Lost"
          @cumulative-change="cumulativeChange"
        />
      </div>
    </template>
    <template #body>
      <div class="relative full-height full-width d-flex">
        <Chart
          v-if="chartData"
          :labels="labels"
          :series="chartData"
          @point-click="handleClick"
          @point-hover="setCurrentPoint"
        >
          <template #tooltip>
            <ComparisonTooltip
              v-if="currentPoint"
              :point="currentPoint"
              metric="Opportunities"
              :format-value="formatValue"
              format-date
            />
          </template>
        </Chart>
        <img v-else class="skeleton" :src="LineChartSkeletonImg" />
      </div>
    </template>
  </BoxCard>
</template>

<script>
import { mapState } from "vuex";
import {
  formatComparisonSeriesData,
  getComparisonLegend,
  timeSeriesChartClick
} from "@/lib/charts.js";

import BoxCard from "@/components/BoxCard.vue";
import Chart from "@/components/Chart/Chart.vue";
import ComparisonTooltip from "@/components/Chart/ComparisonTooltip.vue";
import LineChartSkeletonImg from "@/images/line_chart_skeleton.png";
import ChartHeader from "./ChartHeader.vue";

export default {
  components: {
    BoxCard,
    Chart,
    ComparisonTooltip,
    ChartHeader
  },
  data() {
    return {
      chartData: null,
      data2: [],
      labels: [],
      currentPoint: null,
      cumulative: true,
      LineChartSkeletonImg
    };
  },
  computed: {
    ...mapState({
      dashboardFilters: "dashboardFilters",
      data: function ({ dashboardData }) {
        return dashboardData.opportunities
          ? dashboardData.opportunities.data
          : [];
      },
      baseDetailReportURL: function ({ dashboardData }) {
        return dashboardData.opportunities
          ? dashboardData.opportunities.base.detail_report_url
          : "";
      }
    })
  },
  watch: {
    data(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.generateChartData();
      }
    }
  },
  mounted() {
    this.generateChartData();
  },
  methods: {
    cumulativeChange(value) {
      this.cumulative = value;
      this.generateChartData();
    },
    formatValue(value) {
      return value ? value.toLocaleString("en-us") : "--";
    },
    generateChartData() {
      if (this.data.length) {
        const legend = getComparisonLegend();
        const chart = formatComparisonSeriesData(
          this.data,
          legend.base,
          legend.comparison,
          this.cumulative ? "cumulative" : "value",
          this.dashboardFilters.period
        );
        this.chartData = chart.chartData;
        this.labels = chart.labels;
      }
    },
    handleClick(e) {
      return timeSeriesChartClick(this.data, e);
    },
    setCurrentPoint(e) {
      this.currentPoint = this.data[e.point.index];
    }
  }
};
</script>

<style lang="scss" scoped>
.skeleton {
  max-height: 85%;
  max-width: 100%;
  margin: auto;
  display: block;
}
</style>
